document.addEventListener("turbolinks:load", () => {
  const headerMain = document.querySelector(".header-main");

  if (window.scrollY) {
    headerMain.classList.add("header-main--solid");
  }
});
